import { styled } from '@mui/system';
import { Autocomplete, TextField, AccordionDetails} from '@mui/material';

export const TabHeaderContainer = styled('div')({
  minHeight: '54px',
  borderBottom: '2px solid #E1E4E7'
});

export const TabHeader = styled('div')({
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '17px',
  color: '#000000'
});

export const Details = styled(AccordionDetails)({
  backgroundColor: 'white',
  padding: '0px 16px'
});

export const Dropdown = styled(Autocomplete)({
  width: '100%',
  marginTop: '8px'
});

export const DropDownText = styled(TextField)({
  display: 'flex',
  alignItems: 'center',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '16px',
  lineHeight: '24px'
});